import mutations from './mutations'
import actions from './actions'
import getters from './getters'

import workflowStepRequirement from '../assets/_workflowStepRequirement'


export default {
  namespaced: true,
  state: {
    lifeSelectionList: [],
    lifeList: {

    },
    newLife: {
      workflowStepRequirement: workflowStepRequirement.requirements,
      workflowCurrentStep: 0,
      policyTypeList: [],
      policyFields: [],
      policyID: -1,
      paymentMethodID: -1,
      approveAgent: {
        chinese: '',
        english: ''
      },
      originalAgent: {
        chinese: '',
        english: ''
      },
      currentAgent: {
        chinese: '',
        english: ''
      },
      insurer: {
        chinese: '',
        english: ''
      },
      policyOwner: {
        chinese: '',
        english: ''
      },
      productName: {
        chinese: '',
        english: ''
      },
      originalReferrer: {
        chinese: '',
        english: '',
      },
      isRejected: false,
      isCompleted: false,
      lifeGeneralInfo: {

        riders: [],
        productID: -1,
        policyNumber: '',
        policyReference: '',
        policyStatus: '',
        applicationDate: '',
        applicationReceivedDate: '',
        lastPaymentDate: '',
        conditionalAssignmentFlag: 'Y',
        policyCurrency: 'HKD',
        // originalReferrer: -1,
        // originalAgent: -1,
        // currentAgent: -1,
        approveAgent: -1,
        policyTerm: 0,
        beneficiary: '',
        thirdParty: '',
        policyOwner: -1,
        policyAgentChangeReason: '',
        policyAgent: [{
          agentID: -1,
          agentSplitRate: '',
          isActive: "Y",
          isServiceAgent: "Y",
          effectiveDate: '',
          expiryDate: ''
        }],
        insurer: -1,
        docs: {},
        attachment: [],
        remarks: '',
        paymentTerm: 0,
        premiumType: 'A',
        // Model Premiums
        totalPremiums: 0,
        // Levy
        levy: 0,
        paymentMethod: "",
        companyBank: "",
        paymentReference: "",
        paymentDate: "",
        paymentAmount: 0,
        premiumAmount: 0,
        remarks: '',
        // premiumPaid: 0,
        sentOutDate: '',
        sentOutMedium: '',
        sentOutReference: '',
        commencementDate: '',
        issueDate: '',
        companyReceiveDate: '',
        agentReceiveDate: '',
        customerReceiveDate: '',
        version: 1,
      },
      lifeTypeInfo: {},
      lifeAttachments: [],
      fields: {
        policyAgent: { disabled: false, hide: true },
        riderSection: { disabled: true, hide: true },
        welcomeLetterGenerateBtn: { disabled: true, hide: true },
        orSection: { disabled: true, hide: true },
        saveBtn: { disabled: true, hide: true },
        nextBtn: { disabled: false, hide: false },
        prevBtn: { disabled: true, hide: true },
        inforceBtn: { disabled: true, hide: true },
        rejectBtn: { disabled: true, hide: true },
        policyInfomation: { disabled: false, hide: false, value: null },
        productName: { disabled: false, hide: false, value: '' },
        policyNumber: { disabled: false, hide: false, value: '' },
        deleteBtn: { disabled: false, hide: false },
        policyReference: { disabled: false, hide: false, value: '' },
        applicationDate: { disabled: false, hide: false, value: '' },
        applicationReceivedDate: { disabled: false, hide: false, value: '' },
        policyCurrency: { disabled: false, hide: false, value: '' },
        initialPremium: { disabled: false, hide: false },
        modalPremium: { disabled: false, hide: false },
        conditionalAssignmentFlag: { disabled: false, hide: false, value: '' },
        policyTerm: { disabled: false, hide: false, value: 0 },
        originalAgent: { disabled: false, hide: false, value: '' },
        currentAgent: { disabled: false, hide: false, value: '' },
        originalReferrer: { disabled: false, hide: false, value: '' },
        policyOwner: { disabled: false, hide: false, value: '' },
        insurer: { disabled: false, hide: false, value: '' },
        thirdParty: { disabled: false, hide: false, value: '' },
        beneficiary: { disabled: false, hide: false, value: '' },
        docs: { disabled: false, hide: false, value: '' },
        paymentTerm: { disabled: false, hide: false },
        premiumType: { disabled: false, hide: false, value: '' },
        actuallyPaid: { disabled: false, hide: false, value: 0 },
        paymentMethod: { disabled: false, hide: false, value: '' },
        // paymentAmount: { disabled: false, hide: false },

        companyBank: { disabled: false, hide: false, value: null },
        paymentReference: { disabled: false, hide: false, value: '' },
        remarks: { disabled: false, hide: false, value: '' },
        sentOutDate: { disabled: false, hide: true, value: '' },
        sentOutMedium: { disabled: false, hide: true, value: null },
        sentOutReference: { disabled: false, hide: true, value: '' },

        issueDate: { disabled: false, hide: true, value: '' },
        commencementDate: { disabled: false, hide: true, value: '' },
        welcomeLetterSentOutDate: { disabled: true, hide: true, value: null },
        companyReceiveDate: { disabled: false, hide: true, value: '' },
        agentReceiveDate: { disabled: false, hide: true, value: '' },
        customerReceiveDate: { disabled: false, hide: true, value: '' },
        totalSinglePremiumPaid: { disabled: false, hide: true, value: 0 },
        totalRegularPremiumPaid: { disabled: false, hide: true, value: 0 },
        totalPremiums: { disabled: false, hide: true, value: 0 },
        levy: { disabled: false, hide: false, value: 0 },
        // courierNo: { disabled: false, hide: true, value: '' },
      }
    },
    trueFalseOptions: [
      { text: 'Yes', value: "Y" },
      { text: 'No', value: "N" }
    ],
    allSelections: [],
  },
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/Osm/LifePolicy/store/index.js